var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[(_vm.isAuthenticated)?[_c('sidebar-app',{attrs:{"user":_vm.user}}),_c('div',{staticClass:"main"},[_c('header-app',{attrs:{"user":_vm.user,"version":_vm.version}}),_c('div',{staticClass:"main-content"},[_c('router-view')],1)],1)]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }